import React from 'react'
// import '../home/home.module.css'

export default function Index(){

    // const subjects = [
    //     {
    //         name: "Mystery School",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image3.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "School Layman",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image1.png",
    //         pageRouter: "school-symbolism",
    //     },
    //     {
    //         name: "Science and Spirituality",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image2.png",
    //         pageRouter: "",
    //     },

    //     {
    //         name: "Mandala YogaMaya",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image4.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Raja and Kundalini Yoga",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image5.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Karma and Reincarnation",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image7.png",
    //         pageRouter: "",
    //     },

    //     {
    //         name: "Oracular Divination ",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image13.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "ROTA the Wheel",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image14.png",
    //         pageRouter: "rota-the-wheel",
    //     },
    //     {
    //         name: "Neoplatonic Theurgy",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image6.png",
    //         pageRouter: "",
    //     },


    //     {
    //         name: "Jungian Psychology",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image15.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "The Celebratory Wheel",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image8.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Re-imaging the Family",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image9.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Teaching Children",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image10.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Teaching Adolescents",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image11.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Teaching Young Adults",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image12.png",
    //         pageRouter: "",
    //     },



    //     {
    //         name: "Dual Aspect Monism",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image16.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Mystic Christianity ",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/Mystic%2B_christianity_new.webp",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Gods and Goddesses",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image18.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Chi Gong",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image19.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Sacred Scriptures",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image20.png",
    //         pageRouter: "",
    //     },
    //     {
    //         name: "Stoic Philosophy",
    //         image: "https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/sse_image21.png",
    //         pageRouter: "",
    //     },
       
    // ]








    return (
        <>
            {/* <div id="body" className="nodatadashboard">
                <div id="maincontent" className="maincontentinnerpage">
                    <div className="homeblockone">
                        <div className="asmainwrapper">
                            <div className="homeblockoneleft">
                                <div className="bannerLogo">
                                    <div className="logoviewlink"><img alt="viewicon"
                                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /></div>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                                        alt="bannerLogo" />
                                </div>
                                <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE  </h1>
                                <h1 data-text="INFINITE BEING">INFINITE BEING</h1>
                                <h2>Polytheistic Monism and Oracle to the Gods</h2>
                                <div className="bannerboxtxt">


                                    <p>We train Astrologers, Tarot readers and offers a Mystery School for families, children, and adults. We follow the breakthrough new spiritual science of Mandala YogaMaya, Jungian Psychology and the Celebratory wheel of Astrology through the Archetypes of the Tarot.</p>

                                </div>
                            </div>
                        </div>
                    </div>
            
            
                    <div className="homeblocktwo homeblockb4two">
                        <div className="asmainwrapper">
                            <div className="b4onecontainer_flex">

                                <div className="b4one_left_sec">
                                    <div className="b4one_left_div">
                                        <h3>Astrology and Tarot Services</h3>
                                        <h4>Get a reading from one of our professional Diviners! All of our readers
                                            are graduates from the School of Our Divine Infinite Being</h4>
                                        <button className="btnblack"
                                        >Get my reading!</button>
                                    </div>
                                </div>

                                <div className="b4one_right_sec">
                                    <div className="b4one_right_div"><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/trans_b4one_right_circle_img+.webp" /></div>
                                </div>

                            </div>
                        </div>
                    </div>

       
       
                    <div className="homeblocktwo">
                        <div className="asmainwrapper">
                            <div className="countDiv" >
                                <div className="column">
                                    <div className="col4 h-100 homeblocktwocol1">
                                        <h1>Archetypal Astrology</h1>
                                        <h1>Certification</h1>
                                        <button className="btnblack">Apply Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="col4 h-100 homeblocktwocol3">
                                <h1>Tarot Divination</h1>
                                <h1>Certification</h1>
                                <button className="btnblack">Apply Now</button>
                            </div>
                            <div className="col4 h-100 homeblocktwocol2">
                                <h1>MYSTERY SCHOOL </h1>
                                <h1>MEMBERSHIP</h1>
                                <button className="btnblack">Apply Now</button>
                            </div>

                        </div >
                    </div >
                </div >
            </div >


            <div className="homeblockthree">
                <div className="asmainwrapper">
                    <div className="countDiv" >
                        <div className="column">
                            <div className="col9 h-100 homeblockthreecol">
                                <h1>JOIN US SEPTEMBER 14th, 15th, 16th, 17th 2023<br /> FOR 4 FULL DAYS OF TAROT, ASTROLOGY, RITUAL<br /> THEURGY AND YOGA
                                    WITH THE SCHOOL<br /> OF THE DIVINE INFINITE BEING.
                                </h1><a className="btnblack">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="imgblock homeblockthreebgimgleft">
                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblockthreebgimgleft.webp"
                            alt="homeblockthreebgimgleft" />
                    </div>
                </div>
            </div>
  
  
            <div className="homeblockfour">
                <div className="countDiv titleblock" >
                    <div className="column">
                        <div className="col12 h-100">
                            <h1>The School of Our Divine Infinite Being Basis of Practice </h1>
                        </div>
                    </div>
                </div>
                <div className="asmainwrapper">
                    <div className="countDiv homeblockfourcontent" >
                        <div className="column">
                            <div className="col5 imgblock h-100">
                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblockfourblock1bg.webp"
                                    alt="homeblockfourblock1bg" />
                            </div>
                            <div className="col7 contentblock h-100">
                                <div className="bordertop"></div>
                                <p>The School of Our Divine Infinite Being draws from 4 major areas of study and interest. These are first Hellenistic/Roman practices in Astrology, Deities, Mythology, Personifications, Theurgic Platonic Philosophy and early mystic Christianity.   Second is the Hindu Vedanta liturgy and practices in Bhakti, Karma, Dharma, Jana, Kundalini, and Tantra Yoga.  Third is the seminal work of Archetypal Psychology developed by Carl Jung, James Hillman, Richard Tarnas, Keiron Le Grice and the Transpersonal psychology of Robert Assagioli.
                                    And fourth are the theories of Physicist Henry Stapp, Nobel winning Physicist Wolfgang Pauli, Phd. Philosopher Timothy Desmond, the Infamous Psychologist William James and Philosopher Alphard North Whitehead concerning the Ontology of Monism and Dual Aspect Monism in Physics. Specifically, the discipline Mandala YogaMaya created by Timothy Desmond following the latest discoveries in Cosmology, String Theory, Quantum Mechanics and Depth Psychology for engaging synchronicity and the experience of wholeness. </p>
                            </div>
                        </div>
                        <div className="column">
                            <div className="col5 imgblock h-100">
                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblockfourblock2bg.webp"
                                    alt="homeblockfourblock2bg" />
                            </div>
                            <div className="col7 contentblock h-100">
                                <div className="bordertop"></div>
                                <p>We are a polytheistic monism respecting all beliefs and paths worshiping the gods as expressions of the one supreme ultimate nature we term The Divine Infinite Being . Within our school we certify professional Astrologers and Tarot readers to join the great work of Oracular arts as Diviners of fate and providence. These programs are very complete and developed to certify well educated and talented diviners. Our inner mystery school offers programs for teaching children about archetypes, deities, meditation and polytheism through stories, games, and fairy tales. We have youth programs centered around Jungian Psychology, more advanced meditation, and ritual practice. We have family friendly programs that follow the celebratory wheel of Astrology with ritual dedication to the entry of each sign, planets, equinoxes, solstices and the deities of both Hinduism and the Greco/Roman world.

                                </p>
                            </div>
                        </div>
                        <div className="column">
                            <div className="col5 imgblock h-100">
                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblockfourblock3bg.webp"
                                    alt="homeblockfourblock3bg" />
                            </div>
                            <div className="col7 contentblock h-100">
                                <div className="bordertop"></div>
                                <p>For the student of the Divine Infinite Being the “Ultimate” deity as neither male nor female and at the same time equally both. Well phrased in the Chaldean Oracles was “the Divine Parent”. Beyond all dualities is a supreme unified reality that we grasp in its highest through the absolutely equal ecstatic loving embrace of the God and Goddess. This divine highest reality is most clearly identified through the love of Radha/Krishna and Shakti/Shiva of the Hindu liturgy. All Gods have a co-equal Goddess in their ultimate expression and their interplay can be seen throughout the Oracle of our Divine Arcana Tarot. This supreme ultimate reality can be seen most naturally in the Tao de Ching as a wholeness beyond duality.  This wholeness manifests in perfectly balanced opposites as shown in dialectic Monism and the Jung/Pauli Conjecture of Dual Aspect Monism philosophy. Ontologically the School of Our Divine Infinite Being can also be classNameed under Panentheism with the Infinite both transcendent to the Cosmos and within every part as a whole.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  
  
            <div className="homeblockfive">
                <div className="countDiv titleblock withsubtitle" >
                    <div className="column">
                        <div className="col12 h-100">
                            <h1>Subjects of Starting Exploration</h1>
                            <p>The following are starting points of exploration into subjects of interest to the
                                Institute.</p>
                        </div>
                    </div>
                </div>
                <div className="asmainwrapper">
                    <div className="countDiv homeblockfivecontent" >
                        <div className="column">

                            <div className="col4 singleblock h-100">
                                <div className="singleblockcontent">
                                    <div className="imagewrapperclswrapper">
                                        <div className="imagewrappercls">
                                            <img src="" alt="" />
                                        </div>
                                    </div>
                                    <h1></h1>
                                    <a className="btnblack buttonLink">Learn More</a>

                                </div>
                            </div>

                        </div>
                    </div>
                </div >
            </div >


            <div className="homeblockthree">
                <div className="asmainwrapper">
                    <div className="countDiv" >
                        <div className="column">
                            <div className="col9 h-100 homeblockthreecol">
                                <h1>JOIN US SEPTEMBER 14th, 15th, 16th, 17th 2023<br /> FOR 4 FULL DAYS OF TAROT, ASTROLOGY, RITUAL<br />  THEURGY AND YOGA WITH THE SCHOOL<br />   OF THE DIVINE INFINITE BEING.
                                </h1>
                                <a className="btnblack">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="imgblock homeblockthreebgimgleft">
                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblockthreebgimgleft.webp"
                            alt="homeblockthreebgimgleft" />
                    </div>
                </div>
            </div>



            <div className="homeblockseven">
                <div className="asmainwrapper">
                    <div className="countDiv" >
                        <div className="column">
                            <div className="col3 imgblock h-100">
                                <div className="imgblockwrapper">
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/home/homeblocksevenimg.webp"
                                        alt="homeblocksevenimg" />
                                </div>
                            </div>
                            <div className="col9 contentblock h-100">
                                <h1>Eddie Paredes will be teaching 6 different</h1>
                                <h1>tracks at Spirit Con! Including:</h1>
                                <p>The Pagan Mythic and Modern Practice, Energy Medicine and Self-Healing, Develop your <br />Psychic Abilities, The Goddess Shakti and Kundalini Yoga, Tarot Divination Workshop, <br />Not “Who” is the Goddess, but What” is she?</p>
                                <button className="btnblack">Click to see the SpiritCon website
                                    now!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}
